module.exports = __webpack_public_path__ + "img/smd-2.6f3a1bf1.png";